import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { NegocioQualificacaoSearch } from '../negocio-qualificacao-search';

@Injectable({
    providedIn: 'root'
})
export class NegocioQualificacaoDuplicateHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/crm/negocioqualificacao`;
    }

    /** Duplica a qualificação de negócio */
    duplicate(id: number): Observable<NegocioQualificacaoSearch> {
        return this.customHttp.get<NegocioQualificacaoSearch>(`${this.pathApi}/${id}/duplicate`);
    }
}
